<template>
  <vs-popup class="vs-con-loading__container user-edit-popup" id="popup" :title="`Export - ${sheet_obj.title}`"
    @close="onClickClose()" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-alert color="warning" class="h-auto" v-if="sheet_obj.is_email">
        This is a large report to create and will be emailed to your inbox within 10 minutes.
      </vs-alert>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(downloadReportDocument)" autocomplete="off">
          <vx-card noShadow subtitle="">
            <div class="vx-row mb-3" v-for="(fil, index_filter) in sheet_obj.filters" :key="index_filter">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider :vid="`${index_filter}_${fil.key}`" :name="`${index_filter}_${fil.key}`"
                  :rules="fil.required ? 'required' : ''" v-slot="{ errors }">
                  <small class="label">{{ fil.label }}</small>

                  <!-- input type filter -->
                  <vs-input v-if="fil.type === 'input'" v-model="fil.model_value" class="w-full"></vs-input>

                  <!-- dropdown type filter -->
                  <v-select :clearable="true" v-model="fil.model_value" :options="fil.options" label="name"
                    v-if="fil.type === 'dropdown' && !fil.select_type" :reduce="option => option.value" multiple
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="fil.is_hidden" />
                  <v-select :clearable="true" v-model="fil.model_value" :options="fil.options" label="name"
                    v-if="fil.type === 'dropdown' && fil.select_type" :reduce="option => option.value"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="fil.is_hidden" />

                  <!-- date type filter -->
                  <flat-pickr v-if="fil.type === 'date'" class="w-full" :config="flatPkrConfigForDate"
                    v-model="fil.model_value" placeholder="Choose Date" />

                  <!-- month/year date type filter -->
                  <flat-pickr v-if="fil.type === 'month_year_date'" class="w-full" :config="flatPkrConfigForMonthYear"
                    v-model="fil.model_value" placeholder="Choose Date" />

                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div v-if="sheet_obj.filters.length === 0">
              N/A
            </div>
          </vx-card>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button type="filled" button="button" @click.stop.prevent="onClickClearFilters" icon-pack="feather" icon="icon-trash-2" color="danger"
              class="ml-auto mt-2">Clear Filters</vs-button>
            <vs-button icon-pack="feather" :icon="sheet_obj.is_email ? 'icon-inbox' : 'icon-download'" button="submit"
              class="mt-2 ml-2">
              {{ sheet_obj.is_email ? 'Send' : 'Download' }}
            </vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>

  </vs-popup>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const ReportingRepository = RepositoryFactory.get('reporting')
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import Utils from "@/mixins/Utils";
import vSelect from 'vue-select'
import ErrorMessages from '@/mixins/ErrorMessages'
import SuccessMessage from '@/mixins/SuccessMessage'
import { mapActions } from "vuex";

export default {
  name: "DownloadExcelSheetPopUp",
  data() {
    return {
      open: false,
      sheet_obj: {
        filters: []
      },
      root_filters: null
    }
  },
  mixins: [Utils, ErrorMessages, SuccessMessage],
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  methods: {
    ...mapActions({
      fetchCustomers: 'fetchCustomers',
      fetchSuppliers: 'fetchSuppliers',
      fetchFormulations: 'fetchFormulations',
      fetchCustomerLeads: 'fetchCustomerLeads',
      fetchCustomerSources: 'fetchCustomerSources',
      fetchFormulationApplications: 'fetchFormulationApplications',
      fetchStaffs: 'fetchStaffs',
      fetchVamTypes: 'fetchVamTypes'
    }),
    async openPopup(sheet_obj, root_filters) {
      this.sheet_obj = {
        ...sheet_obj,
        filters: sheet_obj.filters ? sheet_obj.filters.map(f => ({
          ...f,
          options: f.options ? [...f.options] : [],
          model_value: null
        })) : []
      }
      if (this.sheet_obj.filters.length === 0) {
        await this.downloadReportDocument()
        return null
      }
      this.open = true
      this.root_filters = root_filters
      await this.setRootFilterValues()
      await this.generateDropdownOptions()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.reset()
        }
      })
    },
    async generateDropdownOptions() {
      const dropdown_filters = this.sheet_obj.filters.filter((x) => x.type === 'dropdown')
      for (let index = 0; index < dropdown_filters.length; index++) {
        const filter = dropdown_filters[index];
        switch (filter.key) {
          case 'customer_id':
            await this.fetchCustomers()
            break;
          case 'supplier_id':
            await this.fetchSuppliers()
            break;
          case 'formulation_id':
            await this.fetchFormulations()
            break;
          case 'customer_lead_id':
            await this.fetchCustomerLeads()
            break;
          case 'customer_source':
            await this.fetchCustomerSources()
            break;
          case 'formulation_applications':
            await this.fetchFormulationApplications()
            break;
          case 'account_handler_id':
            await this.fetchStaffs()
            break;
          case 'vam_types': 
            await this.fetchVamTypes()
            break;
        }
      }
      this.sheet_obj.filters.forEach((x, index) => {
        if (x.type === 'dropdown') {
          this.$set(this.sheet_obj.filters[index], 'options', this.getDropdownData(x.key))
        }
      });
    },
    async setRootFilterValues() {
      if (!!this.root_filters) {
        this.sheet_obj.filters.forEach((x) => {
          const matchKey = (x.root_key && this.root_filters[x.root_key] !== undefined && this.root_filters[x.root_key] !== null && this.root_filters[x.root_key] !== '')
            ? x.root_key
            : ((this.root_filters[x.value] !== undefined && this.root_filters[x.value] !== null && this.root_filters[x.value] !== '') ? x.value : null);

          if (matchKey) {
            this.$set(x, 'model_value', this.root_filters[matchKey])
          }
        })
      }
    },
    async downloadReportDocument() {
      this.$vs.loading()
      try {
        const filter_string = this.sheet_obj.filters
          .filter(x => Array.isArray(x.model_value) ? x.model_value.length > 0 : !!x.model_value)
          .map(x => {
            if (x.raw_filters) return `${x.value}=${encodeURIComponent(x.model_value.toString())}`
            if (Array.isArray(x.model_value)) return `filter[${x.value}]=${x.model_value.join(',')}`
            return `filter[${x.value}]=${encodeURIComponent(x.model_value.toString())}`
          })
          .join('&')
        const response = await ReportingRepository.downloadExcelSheetData(this.sheet_obj.end_point, filter_string)
        if (this.sheet_obj.is_email) {
          this.showSuccessMessage('Email will be emailed to your inbox within 10 minutes')
        } else {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${this.sheet_obj.title}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        }
        this.open = false
      } catch (e) {
        // this.showErrorMessageWithTitle('Warning', 'No data found for given filters')
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "No Data Found",
          text: "There are no records available for the selected filters. Please adjust your filters and try again.",
          acceptText: "OK",
        });
      }
      this.$vs.loading.close()
    },
    onClickClearFilters() {
      this.sheet_obj.filters.forEach((x) => {
        this.$set(x, 'model_value', null)
      })
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.reset()
        }
      })
    },
    onClickClose() {
      this.sheet_obj = {
        filters: []
      }
      this.open = false
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
    }
  },
  computed: {
    flatPkrConfigForDate: function () {
      return {
        dateFormat: 'd/m/Y',
      }
    },
    flatPkrConfigForMonthYear: function () {
      return {
        dateFormat: 'm/Y',
        plugins: [
          new MonthSelectPlugin({
            shorthand: true,
            dateFormat: "m/Y",
          })
        ],
      }
    }
  }
}
</script>

<style scoped></style>
